angular
 .module('vppApp')
 .directive('modalDialog',function(){
  return {
    scope: {
      data: '=',
      show: '@',
      voidCode: '&'
    },
    replace: true, // Replace with the template below
    transclude: true, // we want to insert custom content inside the directive
    link: function($scope, element, attrs) {
      $scope.dialogStyle = {};
      // $scope.voidCode({authorizationNumber: authorizationNumber});
      if (attrs.width){
        $scope.dialogStyle.width = attrs.width;
      };
      if (attrs.height){
        $scope.dialogStyle.height = attrs.height;
      };


      $scope.hideModal = function() {
        $scope.$parent.hideModalCallback();

        // $scope.show = false;
        // if($scope.$parent.$parent.hasOwnProperty('modalShown')){
        //   $scope.$parent.$parent.modalShown = false;
        // } else if($scope.$parent.$parent.$parent.hasOwnProperty('modalShown')){
        //   $scope.$parent.$parent.$parent.modalShown = false;
        // } else if($scope.$parent.$parent.$parent.$parent.hasOwnProperty('modalShown')){
        //   $scope.$parent.$parent.$parent.$parent.modalShown = false;
        // } else if($scope.$parent.$parent.$parent.$parent.$parent.hasOwnProperty('modalShown')){
        //   $scope.$parent.$parent.$parent.$parent.$parent.modalShown = false;
        // }
        //
        // document.getElementsByTagName('body')[0].style['overflow'] = "auto";
      };
    },
    controller: SendEmailController,
    templateUrl: '/non-content/templates/modal.html'
  };
});
